import { render, staticRenderFns } from "./address-read-only.vue?vue&type=template&id=05186f29&scoped=true&lang=pug"
import script from "./address-read-only.vue?vue&type=script&lang=ts"
export * from "./address-read-only.vue?vue&type=script&lang=ts"
import style0 from "./address-read-only.vue?vue&type=style&index=0&id=05186f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05186f29",
  null
  
)

export default component.exports